import React from "react";
import { FaRedo } from "react-icons/fa";
import { FilterSelect } from "./MarketplaceBrowseUi";

export default function ProductMarketplaceFiltersPanel({
  draft,
  setDraft,
  categoryOptions = [],
  subCategoryOptions = [],
  subSubCategoryOptions = [],
  locations = [],
  brands = [],
  onApply,
  onClear,
  showReset = true,
  hideCategoryHierarchy = false,
}) {
  return (
    <aside className={`product-marketplace-filters${hideCategoryHierarchy ? " product-marketplace-filters--embedded" : ""}`}>
      <div className="product-marketplace-filters__head">
        <h2>{hideCategoryHierarchy ? "More Filters" : "Filters"}</h2>
        <button type="button" onClick={onClear}>
          Clear All
        </button>
      </div>

      {!hideCategoryHierarchy ? (
        <>
          <FilterSelect
            id="mp-category"
            label="Category"
            value={draft.category}
            placeholder="All Categories"
            options={categoryOptions}
            onChange={(e) => setDraft((d) => ({ ...d, category: e.target.value, subCategory: "", subSubCategory: "" }))}
            onClear={() => setDraft((d) => ({ ...d, category: "", subCategory: "", subSubCategory: "" }))}
          />

          <FilterSelect
            id="mp-subcategory"
            label="Sub Category"
            value={draft.subCategory}
            disabled={!draft.category}
            placeholder="All Sub Categories"
            options={subCategoryOptions}
            onChange={(e) => setDraft((d) => ({ ...d, subCategory: e.target.value, subSubCategory: "" }))}
            onClear={() => setDraft((d) => ({ ...d, subCategory: "", subSubCategory: "" }))}
          />

          <FilterSelect
            id="mp-subsubcategory"
            label="Sub Sub Category"
            value={draft.subSubCategory}
            disabled={!draft.subCategory}
            placeholder="All Sub Sub Categories"
            options={subSubCategoryOptions}
            onChange={(e) => setDraft((d) => ({ ...d, subSubCategory: e.target.value }))}
            onClear={() => setDraft((d) => ({ ...d, subSubCategory: "" }))}
          />
        </>
      ) : null}

      <div className="product-marketplace-filters__field">
        <label htmlFor="mp-min-price">Price Range</label>
        <div className="product-marketplace-filters__price-row">
          <div className="product-marketplace-filters__price-field">
            <span>₹</span>
            <input
              id="mp-min-price"
              type="number"
              placeholder="Min Price"
              value={draft.minPrice}
              onChange={(e) => setDraft((d) => ({ ...d, minPrice: e.target.value }))}
            />
          </div>
          <div className="product-marketplace-filters__price-field">
            <span>₹</span>
            <input
              id="mp-max-price"
              type="number"
              placeholder="Max Price"
              value={draft.maxPrice}
              onChange={(e) => setDraft((d) => ({ ...d, maxPrice: e.target.value }))}
            />
          </div>
        </div>
      </div>

      <details className="product-marketplace-filters__accordion">
        <summary>Country / Location</summary>
        <select
          id="mp-location"
          value={draft.location}
          onChange={(e) => setDraft((d) => ({ ...d, location: e.target.value }))}
        >
          <option value="">All Locations</option>
          {locations.map((loc) => (
            <option key={loc} value={loc}>
              {loc}
            </option>
          ))}
        </select>
      </details>

      <details className="product-marketplace-filters__accordion">
        <summary>Brand</summary>
        <select id="mp-brand" value={draft.brand} onChange={(e) => setDraft((d) => ({ ...d, brand: e.target.value }))}>
          <option value="">All Brands</option>
          {brands.map((brand) => (
            <option key={brand} value={brand}>
              {brand}
            </option>
          ))}
        </select>
      </details>

      <details className="product-marketplace-filters__accordion">
        <summary>MOQ Range</summary>
        <div className="product-marketplace-filters__price-row">
          <input
            id="mp-min-moq"
            type="number"
            placeholder="Min MOQ"
            value={draft.minMoq}
            onChange={(e) => setDraft((d) => ({ ...d, minMoq: e.target.value }))}
          />
          <input
            id="mp-max-moq"
            type="number"
            placeholder="Max MOQ"
            value={draft.maxMoq}
            onChange={(e) => setDraft((d) => ({ ...d, maxMoq: e.target.value }))}
          />
        </div>
      </details>

      <label className="product-marketplace-filters__check">
        <input
          type="checkbox"
          checked={draft.verifiedOnly === "1"}
          onChange={(e) => setDraft((d) => ({ ...d, verifiedOnly: e.target.checked ? "1" : "" }))}
        />
        Verified Sellers Only
      </label>

      <div className="product-marketplace-filters__actions">
        <button type="button" className="product-marketplace-btn product-marketplace-btn--primary" onClick={onApply}>
          Apply Filters
        </button>
        {showReset ? (
          <button type="button" className="product-marketplace-btn product-marketplace-btn--outline" onClick={onClear}>
            <FaRedo aria-hidden /> Reset Filters
          </button>
        ) : null}
      </div>
    </aside>
  );
}
